import { Platform } from 'react-native';

const APP_GROUP = 'group.com.slate.quotes';

let SharedGroupPreferences = null;
if (Platform.OS === 'ios') {
  try {
    SharedGroupPreferences = require('react-native-shared-group-preferences').default;
  } catch (_) {}
}

/**
 * Write a single key-value pair to the App Group UserDefaults.
 * No-ops on Android or if the native module isn't available.
 */
async function setItem(key, value) {
  if (!SharedGroupPreferences) return;
  try {
    await SharedGroupPreferences.setItem(key, value, APP_GROUP);
  } catch (_) {}
}

/**
 * Call after drive state changes or mileage updates.
 * Keeps the widget data in sync with the app.
 */
export async function syncWidgetData({ driveActive, todayMiles, todayTrips, pendingQuotes }) {
  if (Platform.OS !== 'ios' || !SharedGroupPreferences) return;
  await Promise.all([
    setItem('driveActive', driveActive),
    setItem('todayMiles', todayMiles),
    setItem('todayTrips', todayTrips),
    setItem('pendingQuotes', pendingQuotes),
  ]);
}

export async function setDriveActive(active) {
  await setItem('driveActive', active);
}

export async function setTodayMiles(miles) {
  await setItem('todayMiles', miles);
}

export async function setTodayTrips(trips) {
  await setItem('todayTrips', trips);
}

export async function setPendingQuotes(count) {
  await setItem('pendingQuotes', count);
}
